import React from 'react';

const Spinner = () => {
  return (
    <div className="border-gray-300 h-10 w-10 animate-spin rounded-full border-4 border-t-blue-600" />
  );
};

export default Spinner;